import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'prop-types';

const SpacerDiv = styled.div`
    display: block;
    height: ${({ height }) => (height ? `calc(${height} * .85)` : 0)};

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        height: ${({ height }) => (height ? `${height}` : 0)};
    }
`;

const Spacer = ({
    heightString: height = '0',
    anchor = '',
    className = ''
}) => <SpacerDiv id={anchor} {...{ height, className }} />;

Spacer.propTypes = {
    heightString: PropTypes.string,
    anchor: PropTypes.string,
    className: PropTypes.string
};

export default Spacer;
